<template>
  <div
    :class="['items-center justify-center', isMobile ? 'column' : 'row']"
    :style="{ padding: isMobile ? 0 : '92px 0' }"
  >
    <img
      v-if="img"
      style="width: 280px;"
      :class="isMobile ? 'q-mb-xl' : 'q-mr-xl'"
      :src="img"
      alt="claim submitted"
    />
    <div :class="{ 'q-mb-lg': isMobile }">
      <h6 :class="['text-grey-10 medium q-mb-xs', { 'text-center': isMobile }]">
        Your claim has been submitted
      </h6>
      <p :class="['q-mb-lg q-pb-sm', { 'text-center': isMobile }]">
        You can see when you claim is paid by viewing the claim history
      </p>
      <SAIBtn
        :class="isMobile ? 'q-mb-md full-width' : 'q-mr-md'"
        no-caps
        padding="14px xl"
        @click="$emit('restart')"
      >
        <p class="text-weight-medium">Start another claim</p>
      </SAIBtn>
      <SAIBtn
        :class="{ 'full-width': isMobile }"
        outline
        no-caps
        padding="14px xl"
        @click="$emit('close')"
      >
        <p class="text-weight-medium">Close, I'm done</p>
      </SAIBtn>
    </div>
  </div>
</template>

<script>
import { SAIBtn } from 'ecx.saigon.ui.common';

export default {
  name: 'ClaimSubmitted',
  props: {
    img: String,
    isMobile: Boolean
  },
  components: {
    SAIBtn
  }
};
</script>
